import CallOutlinedIcon from "@material-ui/icons/CallOutlined";
import HomeOutlinedIcon from "@material-ui/icons/HomeOutlined";
import FactoryIcon from "@mui/icons-material/Factory";
import FiberNewIcon from '@mui/icons-material/FiberNew';
import PorductLine from "@mui/icons-material/LinearScale";
import Product from "@mui/icons-material/LocalGroceryStore";
import MoveUpIcon from '@mui/icons-material/MoveUp';
import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import { AiFillPieChart, AiOutlineExclamation, AiOutlineStop } from "react-icons/ai";
import { BsCardChecklist, BsFillTrashFill, BsGear, BsGeoAlt, BsLink } from "react-icons/bs";
import {
    FaBarcode,
    FaBoxes,
    FaCamera,
    FaChartPie,
    FaCheck,
    FaCheckCircle,
    FaCircle,
    FaClock,
    FaCog,
    FaColumns,
    FaCopy,
    FaDownload,
    FaEdit,
    FaEraser,
    FaExclamationTriangle,
    FaFileCsv,
    FaFileInvoiceDollar,
    FaFilter,
    FaGripLines,
    FaGripLinesVertical,
    FaHome,
    FaHourglass,
    FaHourglassHalf,
    FaIdCard,
    FaInfoCircle,
    FaKey,
    FaMap,
    FaPause,
    FaPenSquare,
    FaPercentage,
    FaPlay,
    FaPlus,
    FaPrint,
    FaRegCalendarTimes,
    FaRegClock,
    FaRegFileExcel,
    FaRegFilePdf,
    FaRulerVertical,
    FaSignature,
    FaTimes,
    FaTimesCircle,
    FaTrash,
    FaTruck,
    FaTruckLoading,
    FaUser,
    FaUserCheck,
    FaUserFriends,
    FaUsers
} from "react-icons/fa";
import { FiRefreshCw } from "react-icons/fi";
import {
    GiChemicalTank,
    GiDrill,
    GiFarmer,
    GiHamburgerMenu,
    GiMechanicalArm,
    GiStopwatch,
    GiWeight
} from "react-icons/gi";
import { GoStop } from "react-icons/go";
import { GrDocumentTime } from "react-icons/gr";
import { ImCancelCircle, ImPrinter, ImQrcode, ImZoomIn, ImZoomOut } from "react-icons/im";
import { IoMdBusiness } from "react-icons/io";
import { IoArrowBackCircleOutline, IoArrowForwardCircleOutline, IoChevronBackCircleOutline, IoChevronForwardCircleOutline, IoHourglassOutline } from "react-icons/io5";
import { MdRemoveShoppingCart } from "react-icons/md";
import { RiLayoutGridFill, RiLockPasswordFill, RiMessage3Fill, RiRecycleFill, RiTestTubeFill } from "react-icons/ri";
import { SiElasticstack } from "react-icons/si";

/**
 * @author IKlapouch
 * 07/02/2021
 */

export const IconSwitch = ({
    name,
    color,
    size,
    fontSize,
    isHeader,
    label,
    disablePointerEvents
}) => {
    size = isHeader ? 13 : size ? size : 17;
    fontSize = isHeader ? "inherit" : fontSize ? fontSize : "medium";

    /**
     * react-icons/fa      -> size
     * @mui/icons-material -> fontSize
     **/

    /**
     * @mui/icons-material
     * fontSize(String)
     * -inherit
     * -large
     * -medium
     * -small
     **/

    const faProps = { size, color };

    return (
        <>
            {/* Utilizar no "yes" e "no" */}
            {name === "positive" && (
                <FaCheck size={size} color={color ? color : "#5cb85c"} />
            )}
            {name === "negative" && (
                <FaTimes size={size} color={color ? color : "#d9534f"} />
            )}

            {/* checklist Icon */}
            {name === "checklist" && <BsCardChecklist fontSize={fontSize} />}

            {/* Block status Icon */}
            {name === "yes" && <AiOutlineStop size={size} color="#d9534f" />}
            {name === "block" && <AiOutlineExclamation size={size} color="#d9534f" />}
            {name === "no" && <GoStop size={size} color="#5cb85c" />}

            {/* Status Icon */}
            {name === "active" && <FaCheckCircle size={size} color={color ? color : "#5cb85c"} />}
            {name === "canceled" && <FaTimesCircle size={size} color={color ? color : "#d9534f"} />}

            {/*Operetors icon */}
            {(name === "idOperator" ||
                name === "username" ||
                name === "login" ||
                name === "user" ||
                name === "role") && (
                    <FaUsers size={size} color={color ? color : null} />
                )}

            {name === "users" && <FaUserFriends />}
            {/* Operetor Icon  */}
            {name === "nickname" && <FaUser size={size} />}

            {/*Reason for Loss icon */}
            {(name === "motivo" ||
                name === "reason" ||
                name === "description" ||
                name === "malfunction" ||
                name === "idMalfunctionReason" ||
                name === "malfunctionReason" ||
                name === "causeLoss") && (
                    <FaRegFileExcel size={size} color={color ? color : null} />
                )}

            {/* Raw Material Icon*/}
            {(name === "rawMaterialDescription" || name === "rawMaterial") && (
                <FaBoxes size={size} color={color ? color : null} />
            )}

            {/* Qtty Icon */}
            {(name === "qtty" || name === "positionsQty") && (
                <FaChartPie size={size} color={color ? color : null} />
            )}

            {/* Unit Icon */}
            {(name === "unit" || name === "weight") && (
                <GiWeight size={size} color={color ? color : null} />
            )}

            {/* QRCode Icon */}
            {(name === "codeEAN" ||
                name === "productBatch" ||
                name === "batchNumber") && (
                    <ImQrcode
                        style={disablePointerEvents && { pointerEvents: 'none' }}
                        size={size} color={color ? color : null} className="qrcode-icon" />
                )}

            {/* Date Icon */}
            {(name === "lossDate" ||
                name === "accessDateTime" ||
                name === "date" ||
                name === "lastUpdate" ||
                name === "dueDate") && (
                    <FaRegCalendarTimes size={size} color={color ? color : null} />
                )}

            {/* Production Order Icon */}
            {name === "productionOrder" && <FactoryIcon fontSize={fontSize} />}

            {/* Plant Icon */}
            {(name === "plant" || name === "idPlant") && (
                <BsGeoAlt size={size} color={color ? color : null} />
            )}

            {/* Product Icon */}
            {name === "product" && <Product fontSize={fontSize} />}

            {/* Product Line Icon */}
            {name === "productionLine" && <PorductLine fontSize={fontSize} />}

            {name === "historic" && (
                <GrDocumentTime size={size} color={color ? color : null} />
            )}
            {/* Url Icon */}
            {(name === "url" || name === "link") && <BsLink fontSize={fontSize} color={color ? color : null} />}

            {/* Menu Icon */}
            {name === "menu" && <GiHamburgerMenu fontSize={fontSize} color={color} />}

            {/* Homepage Icon */}
            {name === "homepageReport" && <FaHome fontSize={fontSize} />}

            {/* BarCode Icon */}
            {(name === "ean" || name === "barCode" || name === "batch") && (
                <FaBarcode fontSize={fontSize} />
            )}

            {/* Supllier Icon */}
            {name === "supplier" && <FaTruckLoading fontSize={fontSize} />}
            {/* Invoice Icon */}
            {name === "invoice" && <FaFileInvoiceDollar fontSize={fontSize} />}
            {/* Passworld Icon */}
            {(name === "password" ||
                name === "confirmPassword" ||
                name === "newPassword" ||
                name === "currentPassword" ||
                name === "confirmNewPassword") && (
                    <RiLockPasswordFill fontSize={fontSize} />
                )}

            {/* Message icon */}
            {name === "message" && <RiMessage3Fill fontSize={fontSize} />}

            {/* Stopwatch icon */}
            {name === "timeWarning" && <GiStopwatch fontSize={fontSize} />}

            {/* Equipment icon */}
            {name === "equipment" && <GiDrill fontSize={fontSize} />}

            {/* TagName MachineArm Icon */}
            {name === "tagName" && <GiMechanicalArm fontSize={fontSize} />}

            {/* Tank icon */}
            {name === "tank" && (
                <GiChemicalTank
                    //style={{transform: "rotate(0.50turn)"}}
                    size={size}
                />
            )}

            {/* Level Icon */}
            {(name === "level" || name === "idLevel") && (
                <FaGripLines fontSize={fontSize} />
            )}

            {/* Aisle Icon */}
            {(name === "aisle" || name === "idAisle") && (
                <FaMap fontSize={fontSize} />
            )}

            {/* Column Icon */}
            {(name === "column" || name === "idColumn") && (
                <FaGripLinesVertical fontSize={fontSize} />
            )}

            {/* Department  Icon */}
            {(name === "department" || name === "idDepartment") && (
                <FaColumns fontSize={fontSize} />
            )}

            {/* Box per Layer  Icon */}
            {name === "boxLayer" && <SiElasticstack fontSize={fontSize} />}

            {/* Rule Icon */}
            {name === "rule" && <FaRulerVertical size={size} />}

            {/* Client/Company Icon */}
            {(name === "customer" || name === "company") && <IoMdBusiness size={size} />}

            {/* Car Icon */}
            {name === "car" && <FaTruck size={size} />}

            {/* Address Icon */}
            {name === "address" && <HomeOutlinedIcon fontSize={fontSize} />}

            {/* Printer Icon */}
            {name === "print" && <ImPrinter size={size} />}

            {/* Farm/ Rural Supplier Icon */}
            {name === "farm" || name === "ruralSupplier" && <GiFarmer size={size} />}

            {/* Phone Icon */}
            {name === "phone" && <CallOutlinedIcon size={size} />}

            {/*Print Icon*/}
            {name === "reprint" && <FaPrint size={size} color={color} />}

            {/*Sample Icon*/}
            {name === "sample" && <RiTestTubeFill size={size} />}
            {/*Hourglass Icon*/}
            {name === "hourglass" && <FaHourglass size={size} color={color} />}
            {/*alt-Hourglass Icon*/}
            {name === "alt-hourglass" && <IoHourglassOutline size={size} color={color} />}
            {/*Copy Icon*/}
            {name === 'copy' && <FaCopy size={size} />}

            {/*Go Back Icon*/ name === 'goBack' && <IoChevronBackCircleOutline size={size} />}
            {/*Advane */ name === 'advance' && <IoChevronForwardCircleOutline size={size} />}

            {name === "newIcon" && <FiberNewIcon size={fontSize} />}

            {name === "fileVersion" && <UploadFileIcon size={fontSize} />}

            {name === "phoneAndroid" && <PhoneAndroidIcon size={fontSize} />}

            {/* Play */ name === 'play' && <FaPlay {...faProps} />}

            {/* Pause */ name === 'pause' && <FaPause {...faProps} />}

            {/* PDF */ name === 'pdf' && <FaRegFilePdf {...faProps} />}

            {/* Info */ name === 'info' && <FaInfoCircle {...faProps} />}

            {/* Delete*/ name === 'delete' && <FaTrash {...faProps} />}

            {/* Signature */ name === 'signature' && <FaSignature {...faProps} />}

            {/* Attention */ name === 'attention' && <FaExclamationTriangle {...faProps} />}

            {/* Clock */ name === 'clock' && <FaClock {...faProps} />}

            {/* Filter */ name === 'filter' && <FaFilter size={size} color={color} />}

            {/* Refresh */ name === 'refresh' && <FiRefreshCw size={size} color={color} />}

            {/* Custom Key*/ name === 'customKey' && <FaKey {...faProps} />}

            {/* Add */ name === 'add' && <FaPlus  {...faProps} />}

            {name === 'previous' && <IoArrowBackCircleOutline size={fontSize} color={"#29438D"} />}

            {name === 'next' && <IoArrowForwardCircleOutline size={fontSize} color={"#29438D"} />}

            {name === 'camera' && <FaCamera size={size} color={"#29438D"} />}

            {/* NFC Card */name === 'nfc' && <FaIdCard size={size} color={color} />}

            {name === 'repartition' && <AiFillPieChart size={size} color={color} />}

            {name === "remove" && (<BsFillTrashFill size={size} color={color ? color : "#000000"} />)}

            {name === "clear" && (<FaEraser size={size} color={color ? color : "#000000"} />)}

            {name === "edit" && (<FaEdit size={size} color={color ? color : "#000000"} />)}

            {name === "modify" && (<FaPenSquare size={size} color={color ? color : "#29438D"} />)}

            {name === "remove1" && (<MdRemoveShoppingCart size={size} color={color ? color : "#29438D"} />)}

            {name === "move" && (<MoveUpIcon size={size} color={color ? color : "#29438D"} />)}

            {name === "circle" && (<FaCircle size={size} color={color ? color : "#29438D"} />)}

            {name === "download" && (<FaDownload size={size} color={color ? color : "#000000"} />)}

            {name === "waitingConfirmationReplecament" && (<FaRegClock size={size} color={color ? color : "#000000"} />)}
            {name === "requestConfirmedReplecament" && (<FaUserCheck size={size} color={color ? color : "#000000"} />)}
            {name === "deliveredReplecament" && (<FaCheck size={size} color={color ? color : "#000000"} />)}
            {name === "canceledReplecament" && (<FaTimes size={size} color={color ? color : "#000000"} />)}
            {name === "divergentReplecament" && (<FaExclamationTriangle size={size} color={color ? color : "#000000"} />)}

            {name === "config" && (<FaCog size={size} color={color ? color : "#000000"} />)}

            {name === "quantityEst" && <GiWeight size={size} color={color ? color : "#000000"} />}

            {name === "zoomIn" && <ImZoomIn size={size} />}

            {name === "zoomOut" && <ImZoomOut size={size} />}

            {name === "csv" && <FaFileCsv size={size} />}

            {name === "recicle" && <RiRecycleFill size={size} color={color} />}

            {name === "positions" && <RiLayoutGridFill size={size} color={color} />}

            {name === "percentage" && <FaPercentage size={size} color={color} />}

            {(name === "cipTimeMinutes" || name === "rinseTimeMinutes" || name === "totalCycleTimeMinutes") && <FaHourglassHalf size={size} color={color} />}

            {name === "totalProdPerHour" && <FaBoxes size={size} color={color} />}

            {name === "gear" && <BsGear size={size} color={color} />}

        </>
    );
};
